export const DATA_HOOKS = {
    label: 'labelledElement-label',
    childrenWrapper: 'labelledElement-children',
};
//# sourceMappingURL=LabelledElement.constants.js.map